<script>
import { pageTitleMixin } from '@ubic/vue-mixins';
import { permissions } from '@/constants';
import ErrorAccessDenied from '@/components/ErrorAccessDenied';
import SkippersList from './components/SkippersList';
import ProjectsSummary from './components/ProjectsSummary';
import WorkersList from './components/WorkersList';
import service from './service';

export default {
  pageTitle: 'Сводка',
  mixins: [pageTitleMixin],
  computed: {
    hasReadPermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.STATISTICS_READ);
    },
  },
  render () {
    if (!this.hasReadPermission) {
      return (
        <ErrorAccessDenied />
      );
    }

    const { $style } = this;

    return (
      <div>
        <u-title>
          Сводка
        </u-title>

        <section class={$style.section}>
          <u-title level="2">
            Не отметившиеся
          </u-title>

          <SkippersList getListService={service.getSkippers} />
        </section>

        <section class={$style.section}>
          <ProjectsSummary getDataService={service.getProjects} />
        </section>

        <section class={$style.section}>
          <WorkersList getDataService={service.getWorkersList} />
        </section>

        <section class={$style.section}>
          Здесь будет больше сводных отчетов
        </section>
      </div>
    );
  },
};
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.section {
  & + & {
    margin-top: 2em;
  }
}
</style>
